/* LONGTIEN theme JS — mobile nav, sticky ATC, variant selection. Kept tiny for Core Web Vitals. */
(function () {
  // Mobile nav toggle
  var toggle = document.querySelector('.site-header__toggle');
  var nav = document.querySelector('.site-header__nav');
  if (toggle && nav) {
    toggle.addEventListener('click', function () {
      var open = nav.classList.toggle('is-open');
      toggle.setAttribute('aria-expanded', open ? 'true' : 'false');
    });
  }

  // Sticky add-to-cart: show when the main ATC scrolls out of view (mobile only via CSS)
  var stickyBar = document.querySelector('[data-sticky-atc]');
  var anchor = document.querySelector('[data-atc-anchor]');
  if (stickyBar && anchor && 'IntersectionObserver' in window) {
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        stickyBar.classList.toggle('is-visible', !e.isIntersecting);
      });
    }, { threshold: 0 });
    io.observe(anchor);
    var stickyBtn = stickyBar.querySelector('[data-sticky-submit]');
    if (stickyBtn) {
      stickyBtn.addEventListener('click', function () {
        var form = document.querySelector('form[data-product-form]');
        if (form) form.submit();
      });
    }
  }

  // Variant radio selection (visual state + price + hidden id)
  document.querySelectorAll('[data-variant-option]').forEach(function (label) {
    label.addEventListener('click', function () {
      document.querySelectorAll('[data-variant-option]').forEach(function (l) {
        l.classList.remove('is-selected');
      });
      label.classList.add('is-selected');
      var idInput = document.querySelector('[data-variant-id]');
      if (idInput && label.dataset.id) idInput.value = label.dataset.id;
      var priceEl = document.querySelector('[data-price]');
      if (priceEl && label.dataset.price) priceEl.textContent = label.dataset.price;
      var stickyPrice = document.querySelector('[data-sticky-price]');
      if (stickyPrice && label.dataset.price) stickyPrice.textContent = label.dataset.price;
      var atcPrice = document.querySelector('[data-atc-price]');
      if (atcPrice && label.dataset.price) atcPrice.textContent = label.dataset.price;
      // Disable buy buttons when the chosen variant is sold out
      var available = label.dataset.available !== 'false';
      var form = document.querySelector('form[data-product-form]');
      var submitBtn = form ? form.querySelector('button[type="submit"]') : null;
      if (submitBtn) submitBtn.disabled = !available;
      var stickySubmit = document.querySelector('[data-sticky-submit]');
      if (stickySubmit) stickySubmit.disabled = !available;
    });
  });
})();
